type ClassValue = string | number | boolean | undefined | null | ClassArray | ClassDictionary

interface ClassDictionary {
  [id: string]: any
}

interface ClassArray extends Array<ClassValue> {}

function clsx(...classes: ClassValue[]): string {
  const result: string[] = []
  
  for (let i = 0; i < classes.length; i++) {
    const cls = classes[i]
    if (!cls) continue
    
    if (typeof cls === 'string' || typeof cls === 'number') {
      result.push(String(cls))
    } else if (Array.isArray(cls)) {
      const nested = clsx(...cls)
      if (nested) result.push(nested)
    } else if (typeof cls === 'object') {
      for (const key in cls) {
        if (cls[key]) result.push(key)
      }
    }
  }
  
  return result.join(' ')
}

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs.filter(Boolean))
}